import { asyncReduxFilter } from 'containers/Async/actions'
import {
  CLEAR_COMMENT_LIST,
  UPDATE_COMMENT_LIST,
  POST_COMMENT,
  POST_COMMENT_START,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
  FETCH_COMMENTS,
  FETCH_COMMENTS_START,
  FETCH_COMMENTS_SUCCESS,
  FETCH_COMMENTS_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

// Sagas actions, slowly replace the dispatch actions
const fetchComments = (projectId, revision) => ({ type: FETCH_COMMENTS, projectId, revision })
const fetchCommentsStart = () => ({ type: FETCH_COMMENTS_START })
const fetchCommentsSuccess = (comments) => ({ type: FETCH_COMMENTS_SUCCESS, comments })
const fetchCommentsError = (error) => ({ type: FETCH_COMMENTS_ERROR, error })
const postComment = (projectId, revision, comment) => ({ type: POST_COMMENT, projectId, comment, revision })
const postCommentStart = () => ({ type: POST_COMMENT_START })
const postCommentSuccess = () => ({ type: POST_COMMENT_SUCCESS })
const postCommentError = (error) => ({ type: POST_COMMENT_ERROR, error })

// actions that update reducers
const clearCommentList = () => ({ type: CLEAR_COMMENT_LIST })
const updateCommentList = (comments) => ({ type: UPDATE_COMMENT_LIST, comments })
const startFetchCommentAsync = buildAsyncAction(
  FETCH_COMMENTS,
  FETCH_COMMENTS_START,
  [FETCH_COMMENTS_ERROR, FETCH_COMMENTS_SUCCESS]
)

export {
  fetchComments,
  fetchCommentsStart,
  fetchCommentsSuccess,
  fetchCommentsError,
  postComment,
  postCommentStart,
  postCommentSuccess,
  postCommentError,
  clearCommentList,
  updateCommentList,
  startFetchCommentAsync,
}
